//Angular
import { Component, OnInit, ViewContainerRef,ChangeDetectionStrategy, ViewEncapsulation, Compiler, Inject, Renderer } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";

//Services
import { ComponentHelperService } from "./../../../../services/core/component-helper.service";
import { ClientAreaService } from "./../../../../services/settings/client-area.service";
import { LanguageService } from "./../../../../services/cms/language.service";
import { AuthService } from "./../../../../services/core/auth.service";
import { CmsComponentService } from "./../../../../services/cms/cms-component.service";
import { RoutesService } from "./../../../../services/core/routes.service";
import { SeoService } from "./../../../../services/core/seo.service";
import { ScriptService } from "./../../../../services/cms/script.service";
import { BreadcrumbsService } from '../../../../services/cms/breadcrumbs.service';
import { TranslateService } from "@ngx-translate/core";

//Models
import { SeoViewModel } from "./../../../../models/core/seo";
import { ClientAreaOrderDetails } from "./../../../../models/settings/client-area";
import { Md5 } from "ts-md5/dist/md5";
import { Breadcrumbs } from '../../../../models/cms/breadcrumbs';

import { Subscription } from 'rxjs/Subscription';
import { DomSanitizer, DOCUMENT } from "@angular/platform-browser";
import { PaypalService } from "../../../../services/core/paypal.service";
import { Mappings } from "../../../../shared/mapping";

@Component({
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.Emulated,
    template: ""
})

export class CartSubmittedComponent implements OnInit {
    constructor
        (
            private _compiler: Compiler,
            private componentHelper: ComponentHelperService,
            private _elementRef: ViewContainerRef,
            private route: ActivatedRoute,
            private cmsComponentService: CmsComponentService,
            @Inject('isBrowser') private isBrowser: boolean,
            private seo: SeoService,
            private renderer: Renderer,
            @Inject(DOCUMENT) private document: any,
            private scriptService: ScriptService
        ) { }

    subManager = new Subscription();

    ngOnInit() {
        //Depending on the type of the list, a different template is used
        let orderId: string;
        let header: any;
        let headDataSub = this.cmsComponentService.getHeaderData().subscribe(result => {
            header = result;
            let SideMenuData = this.cmsComponentService.getSideMenuData().subscribe(result1 => {
                if (result1.Categories) {
                    header.Categories = result1.Categories;

                }
            });
            this.subManager.add(SideMenuData);
        });
        this.subManager.add(headDataSub);
        //Reading order id from url
        //If id is set, then the information is retrived by id, else the not found page is showed
        let paramsSub = this.route.params.subscribe(params => {
            let templateHtml: string;
            let id = params['id'];

            if (id !== undefined) {
                orderId = id;

                let cartSub = this.cmsComponentService.getShoppingCartSubmittedData(orderId).subscribe(result => {
                    if (result.SeoInformation) {
                        result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                        result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
                    }

                    if (this.isBrowser) {
                        //Creating subcomponent whith the selected template to inject
                        let subComponent = this.createSubComponent(result,header);

                        //injecting created component (OK)
                        this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
                    }
                    else {
                        let scriptId = this.scriptService.getSystemPageRowId_OrderId(this.scriptService.cartSubmittedId, orderId);

                        //-- Get head and body scripts
                        this.scriptService.setupExternalScripts(result, this.scriptService.typeSystemPage, scriptId);

                        //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                        this.seo.setSeoMetaData(this.document, this.renderer, result.SeoInformation)
                        this.seo.generateSeoDomServerSide(this.document, this.renderer, result.SeoInformation);
                    }
                });

                this.subManager.add(cartSub);
            }
        });

        this.subManager.add(paramsSub);
    }

    ngOnDestroy() {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    }

    private createSubComponent(cartSubmittedData: any,header:any) {
        @Component({
            template: cartSubmittedData.TemplateHtml
        })

        class ChildComponent implements OnInit {
            constructor
                (
                    private router: Router,
                    private clientAreaService: ClientAreaService,
                    private languageService: LanguageService,
                    private authService: AuthService,
                    private routesService: RoutesService,
                    private seoService: SeoService,
                    @Inject('isBrowser') private isBrowser: boolean,
                    private _elementRef: ViewContainerRef,
                    private scriptService: ScriptService,
                    private breadcrumbsService: BreadcrumbsService,
                    private translateService: TranslateService,
                    private sanitizer: DomSanitizer,
                    private paypalService: PaypalService,
                    private mappings: Mappings
                ) { }

            footerData: any = cartSubmittedData.footerData;
            headerData: any = header;
            private areaClientiName: string[] = this.routesService.getRoutePath('AREA CLIENTI - STATISTICHE');
            authentication = this.authService.GetData();
            clientArea: ClientAreaOrderDetails = cartSubmittedData.OrderDetail;
            private seoInfo: SeoViewModel = cartSubmittedData.SeoInformation;
            private pageIsInit: boolean = false;
            language = this.languageService.getShortLang();

            //cripted orderID with Md5
            criptedOrderID = Md5.hashStr(this.clientArea.OrderId.toString());
            private paymentCompleteUrl: string;
            private paymentUrl: string;
            private isTipologiaPagamentoBonifico = cartSubmittedData.OrderDetail.isTipologiaPagamentoBonifico ? cartSubmittedData.OrderDetail.isTipologiaPagamentoBonifico : false;
            private numeroTrnInvalid: boolean = false;
            private numeroCroInvalid: boolean = false;
            private bonificoUploadUrl = this.sanitizer.bypassSecurityTrustResourceUrl(cartSubmittedData.BonificoUploadUrl);
            private bonificoUploadedFiles: string[] = cartSubmittedData.OrderDetail.BonificoUploadedFilesNames;
            private pageIsAfterViewInit: boolean = false;

            private breadcrumbs: Breadcrumbs[] = cartSubmittedData.BreadcrumbsInfo;


            ngOnInit() {
                setTimeout(x => this.breadcrumbsService.setBreadcrumbs(this.breadcrumbs), 1);
                //adding http before link because paypal redirection doesn't work without paypal
                this.paymentUrl = this.clientArea.PaymentDoneUrl + this.criptedOrderID;

                //url that the user will be redirected to after paying of order via paypal
                this.paymentCompleteUrl = this.paymentUrl.replace('{lang}', this.language);

                this.clientArea.CurrencyCode = "EUR";
                if (this.clientArea.OrderId == 0) {
                    this.router.navigate(this.routesService.getRoutePath('HOME'));
                }
            }

            confirmBonificoDetails() {
                // trim value before sending it to a server
                this.clientArea.BonificoTrn = this.clientArea.BonificoTrn.trim();
                //showing of loading panel after we get all data we need
                this.routesService.showPageLoader();

                this.clientAreaService.updateBonificoPaymentDetails(cartSubmittedData.OrderDetail.OrderId, this.clientArea.BonificoCro, this.clientArea.BonificoTrn)
                    .subscribe(x => {
                        //hiding of loading panel after we get all data we need
                        this.routesService.hidePageLoader();
                        this.hideBonificoModal();
                    },
                        err => {
                        });
            }

            // validate NumeroTrn input
            checkNumeroTrn(inputText: any) {
                inputText = inputText.trim();
                if (inputText.length < 31) {
                    this.numeroTrnInvalid = false;
                }
                else {
                    this.numeroTrnInvalid = true;
                }
            }

            // validate NumeroCro input
            checkNumeroCro(inputNumber: any) {
                if (inputNumber < 99999999999) {
                    this.numeroCroInvalid = false;
                }
                else {
                    this.numeroCroInvalid = true;
                }
            }

            // getting uploaded files for this order and showing it inside of bonifico modal
            getBonificoUploadedFiles() {
                //showing of loading panel after we get all data we need
                this.routesService.showPageLoader();

                this.clientAreaService.getBonificoUploadedFiles(cartSubmittedData.OrderDetail.OrderId).subscribe(x => {
                    this.bonificoUploadedFiles = x;
                    //hiding of loading panel after we get all data we need
                    this.routesService.hidePageLoader();
                })
            }

            showBonificoModal() {
                $("#bonificoModal").modal("show");
            }

            hideBonificoModal() {
                $("#bonificoModal").modal("hide");
            }


            orderDetailsRedirect() {
                //Reading link of the page
                var cartOrderDetailPageUrl = this.routesService.getRoutePath('AREA CLIENTI - ORDINE')[0];

                //Removing system parameter (id)
                cartOrderDetailPageUrl = cartOrderDetailPageUrl.replace(':id', '');

                //Adding Order Id parameter
                cartOrderDetailPageUrl += this.clientArea.OrderId;

                //this.router.navigate([cartOrderDetailPageUrl]);
                (window as any).open(cartOrderDetailPageUrl, "_self");
                
            }

            fileUploadRedirect() {
                //Reading link of the page
                var cartOrderDetailPageUrl = this.routesService.getRoutePath('AREA CLIENTI - ORDINE_PAGE_FROM')[0];

                //Removing system parameter (id)
                cartOrderDetailPageUrl = cartOrderDetailPageUrl.replace(':id', this.clientArea.OrderId);
                cartOrderDetailPageUrl = cartOrderDetailPageUrl.replace(':pagefrom', 'section_upload');

                //this.router.navigate([cartOrderDetailPageUrl]);
                (window as any).open(cartOrderDetailPageUrl, "_self");

            }

            payWithPaypal() {
                let paypalText = "pay_with_paypal";
                let translatePaypal = this.translateService.get(paypalText)["value"];

                let formHtml = '<form ngNoForm action=\"' + this.clientArea.GatewayUrl + '\" method="post" target="_top" class="m0" name="paypalForm" id=\'paypalForm\'>' +
                    '<input type="hidden" name="cmd" value="_xclick">' +
                    '<input type="hidden" name="business"  value=\"' + this.clientArea.GatewayAccount + '\">' +
                    '<input type="hidden" name="item_name"  value=\"' + this.clientArea.OrderNumber + '\">' +
                    '<input type="hidden" name="currency_code" value=\"' + this.clientArea.CurrencyCode + '\">' +
                    '<input type="hidden" name="amount" value=\"' + this.clientArea.TotalCost + '\">' +
                    '<input type="hidden" name="item_number"  value=\"' + this.clientArea.OrderId + '\">' +
                    '<input type="hidden" name="return" value=\"' + this.paymentCompleteUrl + '\">' +
                    '<input type="hidden" name="rm" value="2">' +

                    '<button (click)="payWithPaypal()" *ngIf="clientArea.PaymentDoneUrl != null" class="btn btn-primary  btn-lg" type="button"' +
                    'id="paypal-button-container" name="paypal-button-container" style="width:100%">' +
                    '<i class="fa fa-credit-card"></i> ' + translatePaypal +
                    '</button>' +
                    '</form>';

                //replacing form with values from field because of security reasons - if somebody change html content
                let completePaypalForm = $("#completePaypalFormId").html(formHtml);

                $('#paypalForm').submit();
            }

            payWithNexi() {
                let NexiForm = $("#completeNexiFormId").html()
                let NexiText = "pay_with_nexi";
                let translateNexi = this.translateService.get(NexiText)["value"];
                let formHtml = '<form ngNoForm action=\"' + this.clientArea.NexiModel.requestUrl + '\" method="post" target="_top" class="m0" name="nexiForm" id=\'nexiForm\'>' +
                    '<input type="hidden" name="alias"  value=\"' + this.clientArea.NexiModel.alias + '\"/>' +
                    '<input type="hidden" name="importo"  value=\"' + this.clientArea.NexiModel.importo + '\"/>' +
                    '<input type="hidden" name="divisa"  value=\"' + this.clientArea.NexiModel.divisa + '\"/>' +
                    '<input type="hidden" name="codTrans" value=\"' + this.clientArea.NexiModel.codTrans + '\"/>' +
                    '<input type="hidden" name="url" value=\"' + this.clientArea.NexiModel.url + '\"/>' +
                    '<input type="hidden" name="url_back"  value=\"' + this.clientArea.NexiModel.url_back_ultimoStepCarrello + '\"/>' +
                    '<input type="hidden" name="mac" value=\"' + this.clientArea.NexiModel.mac + '\"/>' +
                    '<input type="hidden" name="tipo_servizio" value="paga_1click"/>' +
                    '<input type="hidden" name="num_contratto" value=\"' + this.clientArea.NexiModel.num_contratto + '\"/>';
                if (this.clientArea.NexiModel.gruppo != null && this.clientArea.NexiModel.gruppo != "") {
                    formHtml += '<input type="hidden" name="gruppo" value=\"' + this.clientArea.NexiModel.gruppo + '\"/>';
                }
                formHtml += '</form>' + NexiForm;
                // formHtml += '</form> <button (click)="payWithNexi()" class="btn btn-primary btn-lg w100" type="button" id="nexi-button-container" name="nexi-button-container">' +
                // '<i class="fa fa-credit-card"></i> ' + translateNexi +
                // '</button>';
                //replacing form with values from field because of security reasons - if somebody change html content
                let completeNexiForm = $("#completeNexiFormId").html(formHtml);

                $('#nexiForm').submit();
            }

            ngAfterViewChecked() {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }

                //-- Set title, setup google analytics and other libraries 
                this.scriptService.setGoogleScripts(this.seoInfo);

                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();

                this.pageIsInit = true;
            }

            ngAfterViewInit(): void {
                if (!this.isBrowser || this.pageIsAfterViewInit) {
                    return;
                }

                //-- If these conditions are not fulfilled, we are not gonna load paypal script, because there is no paypal payment option in the current order.
                if (this.clientArea.PaymentType == 'Paypal' && !this.isTipologiaPagamentoBonifico
                    && this.clientArea.PaymentStatus == 0 && this.clientArea.StrTotalBeforeTax != '0,00' && this.clientArea.IsNewPaypalIntegration) {
                    let userId = this.authService.GetUserId();
                    let params = {
                        CustomerId: userId.toString(),
                        OrderId: this.clientArea.OrderId.toString(),
                        Lang: this.languageService.getLongLang()
                    };

                    //-- Load paypal service and render a button for paypal payment
                    this.paypalService.loadPaypalService(this.mappings.Paypal_JS_Lirary_Url,
                        this.mappings.Web_Api_Create_Paypal_Payment,
                        this.mappings.Web_Api_Execute_Paypal_Payment, params, this.clientArea.PaypalButtonStyle, this.clientArea.UsePaypalProduction);
                }

                this.pageIsAfterViewInit = true;
            }
        }

        return ChildComponent;
    }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/components/inventory/shopping-cart/sys/cart-submitted.component.ts